export default {
  path: '/knowledge',
  name: 'knowledge',
  meta: { title: '企业知识库' },
  children: [
    {
      path: '/knowledge/index',
      name: 'knowledgeIndex',
      component: () => import('@/views/knowledge/index.vue'),
      meta: { title: '企业知识库', subTitle: '沉淀品牌知识，赋能高效创作', key: 'knowledge' },
    },
    {
      path: '/knowledge/detail',
      name: 'knowledgeDetail',
      component: () => import('@/views/knowledge/detail.vue'),
      meta: { title: '知识库详情', subTitle: '沉淀品牌知识，赋能高效创作', key: 'knowledge' },
    },
  ],
};
